<div class="m-2 suggestions-header">
  <yc-i18n
    key="common:textAllSuggestions"
    defaultValue="All Suggestions">
  </yc-i18n>
</div>
<div class="ps-3 mb-3">
  <yc-i18n
    key="common:textFormSuggestionsHelpText2"
    defaultValue="Select the update to view the original text in the form. Suggestions are generated by AI. Review to ensure accuracy.">
  </yc-i18n>
</div>
<div class="m-2 font-875-rem d-flex">
  <yc-i18n
    key="common:textSpellingAndGrammarUpdates2"
    defaultValue="Spelling and grammar updates">
  </yc-i18n>
  <div class="ms-2 suggestions-badge">
    {{ $numberOfSuggestions | async }}
  </div>
</div>

<div class="suggestions-content">
  <div *ngFor="let suggestion of suggestions; let index = index; let last = last;"
    class="suggestion-row ps-3 d-flex justify-content-between align-items-center"
    [class.suggestion-border]="!last"
    [class.is-highlighted]="index === selectedSuggestionIndex">
    <div class="suggestion-link d-flex flex-grow-1"
      (click)="goToComponent(suggestion, index)">
      <ng-container *ngIf="!!suggestion.truncatedCorrection &&
        (index !== selectedSuggestionIndex)">
        {{ suggestion.truncatedCorrection }}
      </ng-container>
      <ng-container *ngIf="!suggestion.truncatedCorrection || index === selectedSuggestionIndex">
        {{ suggestion.correction }}
      </ng-container>
    </div>
    <div>
      <yc-checkbox
        [name]="index + '_suggestion'"
        [label]="suggestion.correction"
        [srOnlyLabel]="true"
        [(value)]="suggestion.selected"
        (valueChange)="onSelectionChange()">
      </yc-checkbox>
    </div>
  </div>
</div>


<!-- Footer -->
<div class="flyout-footer">
  <div class="d-flex align-items-center justify-content-end m-3">
    <!-- Cancel -->
    <yc-button
      class="me-2"
      [link]="true"
      [langKey]="'common:btnCancel'"
      [defaultText]="'Cancel'"
      (onClick)="onCancel()">
    </yc-button>

    <!-- Select All -->
    <yc-button
      class="me-2"
      [link]="true"
      [langKey]="'common:textSelectAll'"
      [defaultText]="'Select all'"
      (onClick)="onSelectAll()">
    </yc-button>

    <!-- Unselect All -->
    <yc-button
      class="me-2"
      [link]="true"
      [langKey]="'common:textUnselectAll'"
      [defaultText]="'Unselect all'"
      (onClick)="onUnselectAll()">
    </yc-button>

    <!-- Apply Changes-->
    <yc-button
      [primary]="true"
      [disabled]="selections.length === 0"
      [langKey]="'common:textApplyUpdates'"
      [defaultText]="'Apply updates'"
      (onClick)="onApplyChanges()">
    </yc-button>
  </div>
</div>